document.addEventListener("DOMContentLoaded", function () {

function clearCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    }
  })
  .then(response => {
    if (response.ok) {
      console.log('Cart cleared successfully');
      // Perform any other actions you want after clearing the cart
    } else {
      console.error('Failed to clear cart');
    }
  })
  .catch(error => {
    console.error('Error clearing cart:', error);
  });
}
  
  clearCart();

  
  const pricingchange = document.querySelector(".puco-toggle__slider");
  const yearlyDiv = document.querySelectorAll(".yearly");
  const monthlyDiv = document.querySelectorAll(".monthly");
  const pricingsub = document.querySelector(".pricingsub");
  const currencyCodePattern = /[A-Z]{3}/;
  const matches = pricingsub.textContent.match(currencyCodePattern);
  const currencyCode = matches[0];
  let isClicked = false;
  var dataUrl1 = "123abc";
  var dataUrl2 = "123abc";
  var datasmt = "123abc";
  function removeAllActiveBoxes() {
    var activeContainers = document.querySelectorAll(".activebox");
    activeContainers.forEach(function (container) {
      container.classList.remove("activebox");
    });
  }

  const planContainers = document.querySelectorAll(".featurecenter");
  const submitButton = document.querySelector(".pricingsubmit");
  const featuretitle = document.querySelectorAll(".featuretitle");
  const submitBtnContainer = document.querySelector(".submitBtnContainer");
  const submitBtnContainerPro = document.querySelector("#std");
  const submitBtnContainerNotPro = document.querySelector("#pro");
  
  
  planContainers.forEach(function (container) {
    container.addEventListener("click", function () {
      const planClass = getPlanClass(container);
      toggleOpacity(planClass);
      updateSubmitBtnOpacity();
    });
  });

  function getPlanClass(container) {
    return Array.from(container.classList).find(
      (cls) => cls === "Intro" || cls === "Grow" || cls === "Pro"
    );
  }

  function toggleOpacity(planClass) {
    const allPlanContainers = document.querySelectorAll(`.${planClass}`);

    if (window.innerWidth < 767) {
      featuretitle.forEach(function (container) {
        container.style.display = "flex";
        submitBtnContainer.style.opacity = "1";
      });
    }
    
    // Reset opacity for all plans
    planContainers.forEach(function (container) {
      container.style.color = "#2c2d2e";
       if (window.innerWidth < 767) {container.style.display = "none";}
      var targetElement = container.querySelector("product-card");
      if (targetElement) {
        targetElement.style.backgroundColor = "#2c2d2e"; // Change the background color of the target element
      }

      var svgElement = container.querySelector(
        'svg[data-name="Minus"], svg[data-name="Checkmark"]'
      );
      // If the SVG element is found, adjust the path's fill color
      if (svgElement) {
        var pathElement = svgElement.querySelector("path");
        if (pathElement) {
          pathElement.setAttribute("fill", "#2c2d2e"); // Change the fill color of the path
        }
      }
      removeAllActiveBoxes();
    });

    // Set new opacity for the selected plan
    var isFirstIteration2 = true;
    allPlanContainers.forEach(function (container) {
      container.style.color = "#ff1d44";
      if (window.innerWidth < 767) {container.style.display = "flex";}
      var targetElement = container.querySelector("product-card");
      if (targetElement) {
        targetElement.style.backgroundColor = "#ff1d44"; // Change the background color of the target element
      }
      var svgElement = container.querySelector(
        'svg[data-name="Minus"], svg[data-name="Checkmark"]'
      );
      // If the SVG element is found, adjust the path's fill color
      if (svgElement) {
        var pathElement = svgElement.querySelector("path");
        if (pathElement) {
          pathElement.setAttribute("fill", "#ff1d44"); // Change the fill color of the path
        }
      }

      // Update data-url

      if (pricingsub.textContent.includes("annually")){
        dataUrl1 = container.getAttribute("data-yurl");
        datasmt = container.getAttribute("data-smtbutton");
        submitButton.setAttribute("href", dataUrl1);
        submitButton.textContent = datasmt;
      }
      else {
        dataUrl2 = container.getAttribute("data-url");
        submitButton.setAttribute("href", dataUrl2);
        datasmt = container.getAttribute("data-smtbutton");
        submitButton.textContent = datasmt;
      }
      if (submitButton.textContent.includes("Contact")) {

        
                 submitBtnContainerPro.style.display ="none";
          submitBtnContainerNotPro.style.display ="flex";
      
      } 
      else {
         submitBtnContainerPro.style.display ="flex";
        submitBtnContainerNotPro.style.display ="none";
      }
      container.classList.add("activebox");
      if (isFirstIteration2) {
        container.classList.add("activebox");
        isFirstIteration2 = false;
      }
    });
  }

  function updateSubmitBtnOpacity() {
    const anyActiveElement = Array.from(planContainers).some(
      (container) => parseFloat(getComputedStyle(container).opacity) === 1
    );
    submitButton.style.opacity = anyActiveElement ? 1 : 0.6;
  }

  // Get all div elements with the specified ID and class
  var detailDivs = document.querySelectorAll(
    "div.products.row.grid.detail"
  );

  var showAllButton = document.querySelector(".showall");

  
  // Listen for click event on the button
  showAllButton.addEventListener("click", function () {
    detailDivs.forEach(function (div) {
      if (div.style.display === "none" || div.style.display === "") {
        div.style.display = "grid";
        showAllButton.innerHTML = `
          Hide more features
        `;
      } else {
        div.style.display = "none";
        showAllButton.innerHTML = `
          Show all features
        `;
      }
    });
  });

 // Listen for click event on the pricing button

  function updateDataUrl(container) {
   
      dataUrl1 = container.getAttribute("data-yurl");
      dataUrl2 = container.getAttribute("data-url");
    // Additional logic for showing/hiding containers based on content
    // ...
  }
  

  
  pricingchange.addEventListener("click", function () {
    updateDataUrl(document.querySelector(".activebox"));  
    pricingchange.classList.toggle("clicked");
    
    if (!isClicked) {
   yearlyDiv.forEach((yearlyDiv) => {
      yearlyDiv.style.display = "block";
    });
    monthlyDiv.forEach((monthlyDiv) => {
      monthlyDiv.style.display = "none";
    });
    pricingsub.textContent = "*Prices in "+currencyCode+", billed monthly";
    submitButton.setAttribute("href", dataUrl2);
  } else {
    yearlyDiv.forEach((yearlyDiv) => {
      yearlyDiv.style.display = "none";
    });
    monthlyDiv.forEach((monthlyDiv) => {
      monthlyDiv.style.display = "block";
    });
    pricingsub.textContent = "*Prices in "+currencyCode+", billed annually";
    submitButton.setAttribute("href", dataUrl1);
  }    

  // Update the click state
  isClicked = !isClicked;
  });
  document.querySelector(".featurecenter.Intro.activebox").click();
});
